import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, Alert, Spinner, Row, Col, Card, Button, ProgressBar, InputGroup, Form } from 'react-bootstrap';
import { LanguageProvider } from '../core/language-provider';
import { DataManager } from '../core/data-manager';
import { LoginManager } from '../core/login-manager';
import { ResourceManager } from '../core/resource-manager';
import { Helmet } from 'react-helmet';
import courseDefault from '../assets/course.jpg';
import banner from '../assets/continue/banner.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import HomeCorsiInEvidenza from '../components/Home/HomeCorsiInEvidenza';
import CorsiInEvidenza from '../components/CorsiInEvidenza';
import CardContiua from '../components/Card/Continua';



export default function Continue() {

    const navigate = useNavigate();
    const [errors, setErrors] = useState('');
    const [data, setData] = useState(null);
    const userInfo = LoginManager.getUserInfo();



    useEffect(() => {
        init()
    }, []);


    async function init() {

        let constraints = [
            {
                "fieldName": "isCompleted",
                "type": "value",
                "value": 0
            }
        ]
        var sorting = {
            'field': 'id',
            'order': 'asc'
        }
        var response = await DataManager.searchItems('gyv_course_user', 1, 1000, sorting, '', [], constraints)
        if (response.success === 1) {
            var t = response.body
            setData(t);
        }
        else {
            setErrors(LanguageProvider.get('errors.get'))
            console.warn(response)
        }
    }





    if (data) {
        return (
            <>
                <Helmet>
                    <title>{LanguageProvider.get('header.continue')}</title>
                </Helmet>

                <Container fluid className='text-white' style={{ backgroundImage: `url(${banner})`, backgroundSize: 'cover', backgroundPosition: 'center', height: '100%' }}>
                    <Container fluid={'md'}>
                        <Row style={{ paddingTop: '75px', paddingBottom: '75px' }}>
                            <Col>
                                <h2 className=''>Continua a guardare</h2>
                                <h6 className='' style={{ maxWidth: 600 }}>Riprendi da dove hai lasciato</h6>
                            </Col>
                        </Row>
                    </Container>

                </Container>


                {errors.length > 0 &&
                    <Alert variant='danger'>
                        {errors}
                    </Alert>
                }

                {data && data.length > 0 ? (
                    <>
                        <Container fluid>
                            <Container fluid={'md'}>
                                <Row className='my-5 justify-content-end'>
                                    <Col md={3} className='ps-0'>
                                        <InputGroup>
                                            <Form.Control style={{ borderStartStartRadius: '20px', borderBottomLeftRadius: '20px', borderColor: 'var(--primary-color)', borderRight: '0' }}
                                                placeholder="Cerca"
                                            />
                                            <InputGroup.Text style={{ borderTopRightRadius: '20px', borderBottomRightRadius: '20px', borderLeft: '0', borderColor: 'var(--primary-color)', backgroundColor: 'white' }}>
                                                <FontAwesomeIcon icon='search'></FontAwesomeIcon></InputGroup.Text>
                                        </InputGroup>
                                    </Col>
                                </Row>
                                <Row className='mt-5 mb-5'>
                                    {data.map((item, j) => {
                                        var image = item.image ? ResourceManager.getFileUrl(item.image, 'course') : courseDefault
                                        return (
                                            <Col xs={12} md={6} lg={4} key={j}>
                                                <CardContiua data={item}></CardContiua>

                                            </Col>
                                        )
                                    })}

                                </Row>

                            </Container>

                        </Container>
                        <CorsiInEvidenza />
                    </>
                ) : (
                    <><Row>
                        <Col className='text-center'>
                            <p className='text-muted text-center'>Nessuna corso completato.</p>
                            <Button className='rounded-pill' onClick={() => navigate('/corsi')}>Vai ai corsi</Button>
                        </Col>
                    </Row></>
                )}



            </>
        )
    }
    else {
        return (
            <Container fluid="md" className='mt-5 mb-5'>
                {errors.length > 0 &&
                    <Alert variant='danger'>
                        {errors}
                    </Alert>
                }
                <div className='text-center p-5'>
                    <Spinner animation="border" variant="primary" />
                    <p className='text-primary'>{LanguageProvider.get('defaults.loading')}</p>
                </div>
            </Container>
        )
    }
};